<div class="section-view-copy">
  @if (sections().length) {
    @for (field of objectCopyService.contextFields(); track field) {
      @if (objectCopyService.rootObject()[field.name]?.length) {
        <app-edit-field-context
          [contexts]="objectCopyService.rootObject()[field.name]"
          [field]="field"
          [isLocationOperation]="false"
          [operationContext]="objectCopyService.sectionsContainer().operationContextObjects"
        />
      }
    }

    <app-object-copy-field-selector
      (selectAll)="objectCopyService.toggleSections(true, sections())"
      (clearAll)="objectCopyService.toggleSections(false, sections())"
    />

    @for (section of sections(); track section.name) {
      <app-object-copy-section [section]="section"/>
    }
  }
</div>
